import { render, staticRenderFns } from "./distributeTestPaper.vue?vue&type=template&id=d8d6c0cc&scoped=true"
import script from "./distributeTestPaper.vue?vue&type=script&lang=js"
export * from "./distributeTestPaper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8d6c0cc",
  null
  
)

export default component.exports